import React, { useEffect, useRef } from "react";

const IframeComponent = ({ htmlContent, className, style }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      // Get the iframe's document
      // @ts-expect-error TS2339
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      // Parse the HTML to insert CSP meta tag
      const parser = new DOMParser();
      const parsedDoc = parser.parseFromString(htmlContent, "text/html");

      // Remove all script tags
      const scripts = parsedDoc.getElementsByTagName("script");
      while (scripts.length > 0) {
        // @ts-expect-error TS2531
        scripts[0].parentNode.removeChild(scripts[0]);
      }

      // Write the modified content
      doc.open();
      doc.write(parsedDoc.documentElement.outerHTML);
      doc.close();
    }
  }, [htmlContent]);

  return (
    <iframe
      ref={iframeRef}
      className={className}
      style={{
        ...style,
        transform: "translateZ(0)", // Force GPU acceleration
        willChange: "transform", // Hint to browser about expected changes
        backfaceVisibility: "hidden",
      }}
      title="Iframe Content"
    />
  );
};

export default IframeComponent;
